import callApi from "./callApi";

const token = localStorage.getItem("token");

export const createProduct = async (product, token) => {
  const url = "products/create_product";
  const headers = {
    "Content-Type": "application/json",
    Authorization: `${token}`,
  };
  let body = {
    product,
  };
  return callApi(url, headers, "POST", body);
};

export const uploadCSVFile = async (formData, token) => {
  const url = "products/autosuggest/upload";
  const headers = {
    "Content-Type": "application/json",
    Authorization: `${token}`,
  };
  let body = formData;
  return callApi(url, headers, "POST", body);
};

export const createBulkProduct = async (token) => {
  const url = "products/autosuggest/read";
  const headers = {
    "Content-Type": "application/json",
    Authorization: `${token}`,
  };
  return callApi(url, headers, "GET");
};

export const checkUploadedFile = async (token) => {
  const url = "products/autosuggest/check";
  const headers = {
    "Content-Type": "application/json",
    Authorization: `${token}`,
  };
  return callApi(url, headers, "GET");
};

export const editProduct = async (product, id, token) => {
  let url = `products/${id}`;
  let headers = {
    Authorization: `${token}`,
  };
  let body = {
    product,
  };
  return callApi(url, headers, "PUT", body);
};

export const editSuggestionProduct = async (product, id, token) => {
  let url = `products/autosuggest/${id}`;
  let headers = {
    Authorization: `${token}`,
  };
  let body = {
    product,
  };
  return callApi(url, headers, "PUT", body);
};

export const listAllProducts = async (
  page,
  pageSize,
  token,
  filterName,
  addedBy
) => {
  const url = `products/admin?addedBy=${addedBy}&pageSize=${pageSize}&page=${page}&search=${
    filterName ? filterName : ""
  }`;
  const headers = {
    Authorization: `${token}`,
  };
  return callApi(url, headers, "GET");
};

export const listProductsAll = async (token) => {
  const url = `products/admin?addedBy=admin`;
  const headers = {
    Authorization: `${token}`,
  };
  return callApi(url, headers, "GET");
};

export const listProductsbyCategory = async (
  page,
  pageSize,
  id,
  token,
  addedBy
) => {
  const url = `products/admin?addedBy=${addedBy}&category=${id}&pageSize=${pageSize}&page=${page}`;
  const headers = {
    Authorization: `${token}`,
  };
  return callApi(url, headers, "GET");
};

export const removeProduct = async (id) => {
  const url = `products/${id}`;
  const headers = {
    Authorization: `${token}`,
  };
  return callApi(url, headers, "DELETE");
};

export const removeAutosuggestion = async (id) => {
  const url = `products/autosuggest/${id}`;
  const headers = {
    Authorization: `${token}`,
  };
  return callApi(url, headers, "DELETE");
};

export const getSingleProduct = async (id, token) => {
  const url = `products/${id}`;
  const headers = {
    Authorization: `${token}`,
  };
  return callApi(url, headers, "GET");
};

export const addProductDetail = async (detail, token) => {
  const url = "product-details";
  const headers = {
    "Content-Type": "application/json",
    Authorization: `${token}`,
  };
  let body = {
    detail,
  };
  return callApi(url, headers, "POST", body);
};

export const editProductDetail = async (detail, id, token) => {
  let url = `product-details/${id}`;
  let headers = {
    Authorization: `${token}`,
  };
  let body = {
    detail,
  };
  return callApi(url, headers, "PUT", body);
};
export const deleteProductDetail = async (id, token) => {
  const url = `product-details/${id}`;
  const headers = {
    Authorization: `${token}`,
  };
  return callApi(url, headers, "DELETE");
};

export const removeProductReview = async (id, token) => {
  const url = `reviews/remove/${id}`;
  const headers = {
    Authorization: `${token}`,
  };
  return callApi(url, headers, "DELETE");
};

export const editProductLinks = async (payload, id, token) => {
  let url = `scraper/update/${id}`;
  let headers = {
    Authorization: `${token}`,
  };
  let body = {
    ...payload,
  };
  return callApi(url, headers, "PUT", body);
};

//------------------------categories----------------------->
export const createCategory = async (formData) => {
  const url = "categories";
  const headers = {
    Authorization: `${token}`,
  };
  let body = {
    formData,
  };

  return callApi(url, headers, "POST", body);
};

export const editCategory = async (id, category, token) => {
  let url = `categories/${id}`;
  let headers = {
    Authorization: `${token}`,
  };
  let body = {
    ...category,
  };
  return callApi(url, headers, "PUT", body);
};

export const listCategoriesAll = async (token) => {
  const url = `categories?pageSize=all&page=0`;
  const headers = {
    Authorization: `${token}`,
  };
  return callApi(url, headers, "GET");
};

export const listAllCategories = async (token, pageSize, page, name) => {
  const url = `categories?status=all&pageSize=${pageSize}&page=${page}${
    name ? `&name=${name}` : ""
  }`;
  const headers = {
    Authorization: `${token}`,
  };
  return callApi(url, headers, "GET");
};

export const removeCategory = async (id, token) => {
  const url = `categories/${id}`;
  const headers = {
    Authorization: `${token}`,
  };
  return callApi(url, headers, "DELETE");
};

export const deleteExpert = async (id, token) => {
  const url = `experts/${id}`;
  const headers = {
    Authorization: `${token}`,
  };
  return callApi(url, headers, "DELETE");
};

export const getRegistry = async ({ registryUrl, status, price }) => {
  const url = `registry/registry-web/${registryUrl}?status=${status}${
    price ? `&price=${price}` : ""
  }`;
  return callApi(url, {}, "GET");
};

export const handleWhoPurchased = async (product, id, registryId) => {
  let url = `registry-products/${id}?registryId=${registryId}`;
  let body = {
    product,
  };
  return callApi(url, {}, "PUT", body);
};

export const fetchProductData = async (payload, token) => {
  const url = "scraper/product";
  const headers = {
    Authorization: `${token}`,
  };
  let body = {
    ...payload,
  };

  return callApi(url, headers, "POST", body);
};

export const addProductProvider = async (payload, token) => {
  const url = "scraper/add";
  const headers = {
    Authorization: `${token}`,
  };
  let body = {
    ...payload,
  };

  return callApi(url, headers, "POST", body);
};

export const deleteProductProvider = async (id, token) => {
  const url = `scraper/${id}`;
  const headers = {
    Authorization: `${token}`,
  };
  return callApi(url, headers, "DELETE");
};

export const editReview = async (product, id, token) => {
  let url = `recommendation/review/${id}`;
  let headers = {
    Authorization: `${token}`,
  };
  let body = {
    product,
  };
  return callApi(url, headers, "PUT", body);
};

export const updateProductImages = async (pictures, id, token) => {
  let url = `products/images/update/${id}`;
  let headers = {
    Authorization: `${token}`,
  };
  let body = {
    pictures,
  };
  return callApi(url, headers, "PUT", body);
};

export const convertToAdminAdded = async (id, token) => {
  let url = `products/convert/${id}`;
  let headers = {
    Authorization: `${token}`,
  };
  return callApi(url, headers, "PUT");
};
export const convertToAutoSuggestion = async (id, token) => {
  let url = `products/convert/${id}?type=suggestion`;
  let headers = {
    Authorization: `${token}`,
  };
  return callApi(url, headers, "PUT");
};

export const manageAffiliateTag = async (payload, token) => {
  const url = "tags/affiliatetags";
  const headers = {
    Authorization: `${token}`,
  };
  let body = {
    ...payload,
  };

  return callApi(url, headers, "POST", body);
};

export const updateProductTags = async (token) => {
  const url = "tags/affiliatetags/update";
  const headers = {
    Authorization: `${token}`,
  };

  return callApi(url, headers, "GET");
};

//----------------------Ai Survey ----------->

export const addCategory = async (token, name) => {
  const url = `survey/category/add`;

  const headers = {
    Authorization: ` ${token}`,
  };

  const body = {
    category: { name },
  };

  return callApi(url, headers, "POST", body);
};

export const getCategories = async (token) => {
  const url = `survey/category`;
  const headers = {
    Authorization: ` ${token}`,
  };
  return callApi(url, headers, "GET", null);
};

export const getQuestions = async (token) => {
  const url = `survey/question`;
  const headers = {
    Authorization: ` ${token}`,
  };
  return callApi(url, headers, "GET", null);
};
export const addQuestion = async (token, data) => {
  const url = `survey/question/add`;
  const headers = {
    Authorization: ` ${token}`,
  };
  return callApi(url, headers, "POST", data);
};
